/*
 *
 *  *
 *  *  Copyright (C) THL A29 Limited, a Tencent company. All rights reserved.
 *  *  SPDX-License-Identifier: Apache-2.0
 *  *
 *
 */

import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import createSagaMiddleware from '@redux-saga/core';
import { all } from 'redux-saga/effects';
import { createBrowserHistory } from 'history';
import userReducer from './reducers/user';
import { persistReducer, persistStore } from 'redux-persist';
import sessionStorage from 'redux-persist/es/storage/session';
import { connectRouter, routerMiddleware } from 'connected-react-router';

export const history = createBrowserHistory();

const persistConfig = {
  key: 'userInfo',
  storage: sessionStorage,
  whitelist: ['userInfo'],
};

const reduxDevtools = window.__REDUX_DEVTOOLS_EXTENSION__?.();
const rootReducer = combineReducers({
  Router: connectRouter(history),
  user: persistReducer(persistConfig, userReducer),
});


const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware, routerMiddleware(history));
const enhancers =
  process.env.NODE_ENV === 'production' || reduxDevtools === undefined
    ? compose(middleware)
    : compose(middleware, reduxDevtools);
const store = createStore(rootReducer, enhancers);
const persistor = persistStore(store);
export default store;